(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/assets/javascripts/game-analyzes-helpers.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/assets/javascripts/game-analyzes-helpers.js'); 'use strict';

let cdnBase;
let hbs;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  cdnBase = trinidad.config.options.cdn2;
  hbs = require('hbs');
} else {
  cdnBase = svs.core.config.data.svsconfig.cdn2;
  hbs = Handlebars;
}
hbs.registerHelper('gameAnalysisAvatar', (gameAnalysis, imageType, minImageWidth) => {
  if (!gameAnalysis) {
    return '';
  }
  const authorProfile = gameAnalysis.authorProfile;
  if (!authorProfile) {
    return '';
  }
  const images = authorProfile.images;
  if (!Array.isArray(images) || images.length === 0) {
    return '';
  }
  let image;
  for (let i = 0; i < authorProfile.images.length; ++i) {
    if (authorProfile.images[i].typeName === imageType) {
      image = authorProfile.images[i];
      break;
    }
  }
  if (!image) {
    return '';
  }
  const {
    availableWidths,
    url
  } = image;
  if (!Array.isArray(availableWidths) || availableWidths.length === 0) {
    return '';
  }
  let currentImageWidth = Number.MAX_VALUE;
  availableWidths.forEach(width => {
    if (width < currentImageWidth && width >= minImageWidth) {
      currentImageWidth = width;
    }
  });
  const imageUrl = url.replace('{width}', currentImageWidth);
  return "".concat(cdnBase).concat(imageUrl);
});
hbs.registerHelper('gameAnalysisAvatarFromAuthorProfile', (author, imageType, minImageWidth) => {
  if (!author) {
    return '';
  }
  const authorProfile = author;
  if (!authorProfile) {
    return '';
  }
  const images = authorProfile.images;
  if (!Array.isArray(images) || images.length === 0) {
    return '';
  }
  let image;
  for (let i = 0; i < authorProfile.images.length; ++i) {
    if (authorProfile.images[i].typeName === imageType) {
      image = authorProfile.images[i];
      break;
    }
  }
  if (!image) {
    return '';
  }
  const {
    availableWidths,
    url
  } = image;
  if (!Array.isArray(availableWidths) || availableWidths.length === 0) {
    return '';
  }
  let currentImageWidth = Number.MAX_VALUE;
  availableWidths.forEach(width => {
    if (width < currentImageWidth && width >= minImageWidth) {
      currentImageWidth = width;
    }
  });
  const imageUrl = url.replace('{width}', currentImageWidth);
  return "".concat(cdnBase).concat(imageUrl);
});
 })(window);